import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

// LiteCollection — shown when TransomLite = 'Other'
// When 'CustomGlassCutoutOptions' is selected: show TransomOption, hide LiteCollectionData
// Otherwise: show LiteCollectionData, hide TransomOption
const OPTIONS = [
  { value: 'decorativeglass',           label: 'Decorative Glass'            },
  { value: 'texturedglass',             label: 'Textured Glass'              },
  { value: 'wroughtiron',               label: 'Wrought Iron'                },
  { value: 'commodityglass',            label: 'Commodity Glass'             },
  { value: 'CustomGlassCutoutOptions',  label: 'Custom Glass/Cutout Options' },
];

const LiteCollection = ({
  value = { value: '', label: '' },
  onChange,
  disabled = false,
  onLiteCollectionDataVisible,
  onTransomOptionVisible,
}) => {
  const [selected, setSelected] = useState(value?.value || '');

  useEffect(() => { setSelected(value?.value || ''); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = OPTIONS.find(o => o.value === v)?.label || v;
    setSelected(v);
    onChange({ value: v, label });

    const isCustom = v === 'CustomGlassCutoutOptions';
    onTransomOptionVisible?.(isCustom);
    onLiteCollectionDataVisible?.(!isCustom && v !== '');
  };

  return (
    <div className="a-container">
      <label htmlFor="SdLiteCollection">Lite Collection</label>
      <select id="SdLiteCollection" value={selected} onChange={handleChange} disabled={disabled}>
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LiteCollection;
